<app-template-select [disabled]="disabled" [value]="value" [control]="control" [groups]="groups" [options]="options" [multiple]="multiple" [label]="label" />
